<div>
    @if (isFilterable) {
        <div class="d-flex justify-content-between align-items-center mb-4">
            <h2 class="mb-0">
                @if (showTitle) {
                    @if (title) {
                        {{ title }}
                    } @else {
                        {{ "it.portal.barriers.label" | translate }}
                    }
                }
            </h2>
            <div class="d-flex align-items-center">
                <span class="fw-bold fs-6">
                    {{ resultsTranslationKey | translate: { numResults: pagination?.totaleElementi || 0 } }}
                </span>
                <button
                    class="btn btn-filter"
                    (click)="filterModal.toggle()"
                    [attr.aria-label]="'it.portal.filter' | translate"
                >
                    <span class="material-symbols-outlined me-1"> filter_alt </span
                    >{{ "it.portal.filters.filter" | translate }}
                </button>
            </div>
        </div>

        @if (!isActiveFiltersEmpty) {
            <div class="d-flex align-items-center mb-4">
                <span class="filters-title">{{ "it.portal.filters.active" | translate }}:</span>
                <div class="filter-badges">
                    @for (filter of activeFilters | keyvalue; track filter.key) {
                        <span itBadge="primary">
                            <span>
                                @switch (filter.key) {
                                    @case ("tutti") {
                                        <strong>{{ getFilterLabel(filter.key) | translate }}</strong>
                                    }
                                    @default {
                                        {{ getFilterLabel(filter.key) | translate }}:
                                    }
                                }
                                <strong>
                                    @switch (filter.key) {
                                        @case ("comune") {
                                            {{ filter.value | municipalityName: isPublic | async }}
                                        }
                                        @case ("provincia") {
                                            {{ filter.value | provinceName: isPublic | async }}
                                        }
                                        @case ("utilizzo") {
                                            {{ filter.value | purposeName: isPublic | async }}
                                        }
                                        @case ("tutti") {}
                                        @default {
                                            {{ filter.value }}
                                        }
                                    }
                                </strong></span
                            >
                            <a (click)="clearActiveFilters(filter.key)" class="badge-close material-symbols-outlined">
                                close
                            </a>
                        </span>
                    }
                    <span itBadge="secondary">
                        <a (click)="clearActiveFilters('all')"
                            ><strong>{{ "it.portal.filters.cancel" | translate }}</strong></a
                        >
                    </span>
                </div>
            </div>
        }
        <it-modal #filterModal="itModal" closeButton="false" size="xl">
            <ng-container modalTitle
                ><span class="material-symbols-outlined fs-2 me-2"> filter_alt </span
                >{{ "it.portal.filters.search" | translate }}</ng-container
            >
            <form [formGroup]="filtersForm" class="pt-3">
                <div class="row">
                    <div class="col-lg-4">
                        <it-input
                            type="text"
                            [label]="'it.portal.barriers.name' | translate"
                            formControlName="denominazione"
                        ></it-input>
                    </div>
                    <div class="col-lg-4">
                        <it-select
                            [label]="'it.portal.barriers.purpose' | translate"
                            formControlName="utilizzo"
                            [options]="purposesDeco"
                        >
                            <option [value]="null">{{ "it.portal.all" | translate }}</option>
                        </it-select>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-4">
                        <it-input
                            type="text"
                            [label]="'it.portal.barriers.address' | translate"
                            formControlName="indirizzo"
                        ></it-input>
                    </div>
                    <div class="col-lg-4">
                        <it-autocomplete
                            [label]="'it.portal.municipality' | translate"
                            #municipalityAutocomplete
                            [forceShowLabel]="true"
                            [autocompleteData]="decoService.searchMunicipalitiesPublic"
                            (autocompleteSelectedEvent)="onMunicipalitySelected($event)"
                        />
                    </div>
                    <div class="col-lg-4">
                        <it-select
                            [label]="'it.portal.province' | translate"
                            formControlName="provincia"
                            [options]="provicesDeco"
                            [defaultOption]="
                                'it.portal.select'
                                    | translate: { elem: ('it.portal.province' | translate).toLowerCase() }
                            "
                        >
                        </it-select>
                    </div>
                </div>
            </form>
            <ng-container footer>
                <button itButton="primary" type="button" (click)="getBarriers()" data-bs-dismiss="modal">
                    {{ "it.portal.filters.apply" | translate }}
                </button>
            </ng-container>
        </it-modal>
    }
    <aol-map
        (singleClick)="onSingleClick($event)"
        height="74vh"
        [class.collapsed]="collapsedSidebar"
        class="map-content"
    >
        <div class="details-sidebar">
            <it-sidebar>
                <div class="sidebar-title">
                    <span class="d-flex"
                        ><a (click)="toggleSidebar()" class="material-symbols-outlined me-2"> menu </a>
                        @if (!collapsedSidebar) {
                            {{ "it.portal.map.layer" | translate }}
                        }
                    </span>
                    @if (!collapsedSidebar) {
                        <a (click)="toggleSidebar()"><span class="material-symbols-outlined"> chevron_left </span></a>
                    }
                </div>
                @if (!collapsedSidebar) {
                    <it-accordion [title]="'it.portal.map.basic-background' | translate">
                        <it-radio-button
                            [(ngModel)]="selectedBase"
                            value="osm"
                            [label]="'Open Street Map'"
                        ></it-radio-button>
                        @for (base of baseOrto; track $index) {
                            <it-radio-button
                                [(ngModel)]="selectedBase"
                                [value]="base.code"
                                [label]="base.title"
                            ></it-radio-button>
                        }
                    </it-accordion>
                    <it-accordion [title]="'it.portal.map.administrative-limits' | translate">
                        @for (base of limitiAmm; track $index) {
                            <it-checkbox [(ngModel)]="base.visible" [label]="base.title"></it-checkbox>
                        }
                    </it-accordion>
                    <it-accordion [title]="'it.portal.map.land-registry' | translate">
                        @for (base of catastoAE; track $index) {
                            <it-checkbox [(ngModel)]="base.visible" [label]="base.title"></it-checkbox>
                        }
                    </it-accordion>
                    <it-accordion [title]="'it.portal.map.territory' | translate">
                        @for (base of territorio; track $index) {
                            <it-checkbox [(ngModel)]="base.visible" [label]="base.title"></it-checkbox>
                        }
                    </it-accordion>
                }
            </it-sidebar>
        </div>
        <aol-view [zoom]="8">
            <aol-coordinate [x]="mapCenter[0]" [y]="mapCenter[1]" [srid]="'EPSG:4326'"></aol-coordinate>
        </aol-view>
        @if (isVisibleBase("osm")) {
            <aol-layer-tile>
                <aol-source-osm></aol-source-osm>
            </aol-layer-tile>
        }
        @for (base of baseOrto; track base.code) {
            @if (isVisibleBase(base.code)) {
                <aol-layer-tile [opacity]="base.opacity">
                    <aol-source-tilewms
                        [url]="ortofotoRasPath"
                        [params]="{ LAYERS: 'raster:' + base.code }"
                        attributions="©RAS Ortofoto"
                        crossOrigin="anonymous"
                        serverType="mapserver"
                    ></aol-source-tilewms>
                </aol-layer-tile>
            }
        }
        @for (base of limitiAmm; track base.code) {
            @if (base.visible) {
                <aol-layer-tile [opacity]="base.opacity">
                    <aol-source-tilewms
                        [url]="layersRasPath"
                        [params]="{ LAYERS: 'dbu:' + base.code }"
                        attributions="©RAS"
                        crossOrigin="anonymous"
                        serverType="mapserver"
                    ></aol-source-tilewms>
                </aol-layer-tile>
            }
        }
        @for (base of catastoAE; track base.code) {
            @if (base.visible) {
                <aol-layer-tile [opacity]="base.opacity">
                    <aol-source-tilewms
                        [url]="layersRasPath"
                        [params]="{ LAYERS: 'dbu:' + base.code }"
                        attributions="©Agenzia delle Entrate"
                        crossOrigin="anonymous"
                        serverType="mapserver"
                    ></aol-source-tilewms>
                </aol-layer-tile>
            }
        }
        @for (base of territorio; track base.code) {
            @if (base.visible) {
                <aol-layer-tile [opacity]="base.opacity">
                    <aol-source-tilewms
                        [url]="layersRasPath"
                        [params]="{ LAYERS: 'dbu:' + base.code }"
                        attributions="©RAS"
                        crossOrigin="anonymous"
                        serverType="mapserver"
                    ></aol-source-tilewms>
                </aol-layer-tile>
            }
        }
        <aol-interaction-default></aol-interaction-default>
        <aol-control-defaults></aol-control-defaults>
        <aol-control-fullscreen></aol-control-fullscreen>
        <aol-layer-vector #layer [zIndex]="999">
            <aol-source-cluster [distance]="distance">
                <aol-source-vector>
                    @for (item of items.risultati; track item.uid) {
                        <aol-feature [id]="item.uid">
                            <aol-geometry-point>
                                <aol-coordinate
                                    [x]="+item.wgs84Lon"
                                    [y]="+item.wgs84Lat"
                                    [srid]="'EPSG:4326'"
                                ></aol-coordinate>
                            </aol-geometry-point>
                        </aol-feature>
                    }
                </aol-source-vector>
            </aol-source-cluster>
            <aol-source-vector>
                @for (item of items.risultati; track item.uid) {
                    @if (item.geom) {
                        <aol-feature [id]="item.uid">
                            <aol-geometry-polygon>
                                <aol-collection-coordinates [coordinates]="[item.geomCoord]" [srid]="'EPSG:4326'">
                                </aol-collection-coordinates>
                            </aol-geometry-polygon>
                            <aol-style>
                                <aol-style-stroke [color]="[8, 99, 138]"></aol-style-stroke>
                                <aol-style-fill [color]="[8, 99, 138, 0.5]"></aol-style-fill>
                            </aol-style>
                        </aol-feature>
                    }
                }
            </aol-source-vector>
            <aol-overlay>
                <aol-coordinate [x]="popupContent.coord[0]" [y]="popupContent.coord[1]" [srid]="'EPSG:4326'">
                </aol-coordinate>
                <aol-content class="popover-container">
                    <div class="popover bs-popover-auto fade" [class]="{ show: popupContent.show }" role="tooltip">
                        @if (popupContent.show && popupContent.contents) {
                            <app-barrier-list [data]="popupContent.contents" [isPublic]="isPublic"></app-barrier-list>
                        }
                    </div>
                </aol-content>
            </aol-overlay>
        </aol-layer-vector>
        <aol-layer-vector #layer [zIndex]="998">
            <aol-source-vector>
                @for (item of items.risultati; track item.uid) {
                    @if (item.geom) {
                        <aol-feature [id]="item.uid">
                            <aol-geometry-polygon>
                                <aol-collection-coordinates [coordinates]="[item.geomCoord]" [srid]="'EPSG:4326'">
                                </aol-collection-coordinates>
                            </aol-geometry-polygon>
                            <aol-style>
                                <aol-style-stroke [color]="[8, 99, 138]"></aol-style-stroke>
                                <aol-style-fill [color]="[8, 99, 138, 0.5]"></aol-style-fill>
                            </aol-style>
                        </aol-feature>
                    }
                }
            </aol-source-vector>
        </aol-layer-vector>
    </aol-map>
</div>
